// TODO: Create Seprate folders for Payee and other components
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import AccountsStore from '../../stores/AccountsStore';
import AppStore from '../../stores/AppStore';
import UserManagementStore from '../../stores/UserManagementStore';
import MoveMoneyPayeeStore from '../../stores/MoveMoneyPayeeStore';
import MoveMoneyActionCreator from '../../actions/MoveMoneyActionCreator';
import ManagePayeePage from './ManagePayeePage';
import ManagePaymentsStore from '../../stores/ManagePaymentsStore';
import StringConstant from '../../constants/StringConstants';
import _ from 'lodash';
import BrowserUtils from '../../utils/BrowserUtils';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import MoveMoneyPayeeActionCreator from '../../actions/MoveMoneyPayeeActionCreator';
import { ManageYourPayee } from 'payments-lib';
import AddPayeeOrCompanyMainPage from './AddPayeeOrCompanyMainPage';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import LoaderComponent from '../common/LoaderComponent';
import Helmet from 'react-helmet';
import ManagePaymentActionCreator from '../../actions/ManagePaymentActionCreator';
import InternetBankingActions from '../../actions/InternetBankingActions';
import AnalyticsUtil from '../../utils/AnalyticsUtil';
import config from '../../config/index';
import SvgIcon from '../common/SvgIcon';
import MoveMoneyFromToComponent from './MoveMoneyFromToComponent';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import MoveMoneyApiUtils from '../../utils/MoveMoneyApiUtils';
import { copCheckTriggeredHandler } from '../../utils/COPUtils';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';
import { getSessionInfo } from '../managepayments/ManagePaymentsSMEUtils';
import { BioCatchContext } from '../BioCatchContext';
import { REQUEST_PAYMENT_CONTEXT } from '../../config/BioCatch';
import envConfig from '../../../static/config';

let isNominatedUser = false;
class MoveMoney extends Component {
  constructor(props) {
    super(props);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.onAccountStore = this.onAccountStore.bind(this);
    this.onPayeeStoreChange = this.onPayeeStoreChange.bind(this);
    this.backClick = this.backClick.bind(this);
    this.gotToMoveMoneyPage = this.gotToMoveMoneyPage.bind(this);
    this.showErrorModal = this.showErrorModal.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.showAddPayeePage = this.showAddPayeePage.bind(this);
    this.hideAddPayee = this.hideAddPayee.bind(this);
    this.navigateToManagePayee = this.navigateToManagePayee.bind(this);
    this.backFromManagePayee = this.backFromManagePayee.bind(this);
    this.showMoveMoneyPage = this.showMoveMoneyPage.bind(this);
    this.deletePayeeClick = this.deletePayeeClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.deleteClick = this.deleteClick.bind(this);
    this.editClickFromPayee = this.editClickFromPayee.bind(this);
    this.closeTraPop = this.closeTraPop.bind(this);
    this.goToManagePayees = this.goToManagePayees.bind(this);
    this.creditokClick = this.creditokClick.bind(this);
    this.closed = this.closed.bind(this);
    this.navigateToManagePayments = this.navigateToManagePayments.bind(this);
    this.crossClick = this.crossClick.bind(this);
    this.editManagePayeeClick = this.editManagePayeeClick.bind(this);
    this.handleServiceCall = this.handleServiceCall.bind(this);
    this.viewLoader = this.viewLoader.bind(this);
    this.renderMoveMoneyOrThankYou = this.renderMoveMoneyOrThankYou.bind(this);
    this.refreshMoveMoney = this.refreshMoveMoney.bind(this);
    this.resetPaymentFlag = this.resetPaymentFlag.bind(this);
    this.filterAccountList = this.filterAccountList.bind(this);
    this.renderSoftTokenAlternative =
      this.renderSoftTokenAlternative.bind(this);
    this.getPayees = this.getPayees.bind(this);
    this.handleFileUploadInReview = this.handleFileUploadInReview.bind(this);
    this.state = {
      getFromAccounts: MoveMoneyStore.getFromAccountsFromAccountsStore(),
      getToAccounts: MoveMoneyStore.getToAccountsFromAccountsStore(),
      payeeList: this.getPayees(),
      showErrorModalState: false,
      errorText: '',
      showAddPayeeState: false,
      managePayee: MoveMoneyStore.isDisplayManagePayeePage(),
      deletePayee: false,
      showDelete: false,
      deletePayeeData: '',
      closeModal: true,
      showEditPayee: false,
      editData: '',
      otpButton: '',
      showThankYouPage: false,
      showLoader: false,
      callSoftTokenWindow: false,
      resetPaymentData: false,
      callPaymentService: false, // For softtoken
      amountFocus: false,
      showSoftTokenAlternative: false,
    };
  }
  // enableToAccounts
  componentWillMount() {
    BrowserUtils.setViewPort(1);
    if (
      MoveMoneyStore.getAllPayees() === undefined ||
      MoveMoneyStore.getAllPayees().beneficiaries === undefined
    ) {
      MoveMoneyActionCreator.getFromPayeeList();
    }

    if (ManagePaymentsStore.getBackUrl() === StringConstant.payeeTaskUrl) {
      this.setState({
        managePayee: true,
      });
    }
    isNominatedUser = UserManagementStore.isNominatedUser();
    if (isNominatedUser) {
      this.setState({ payeeLimit: 10 });
    }
    AccountsStore.addChangeListener(this.onAccountStore);
    MoveMoneyStore.addChangeListener(this.onStoreChange);
    MoveMoneyPayeeStore.addChangeListener(this.onPayeeStoreChange);
  }
  componentDidMount() {
    sayLandingMessage('Move money');
    AnalyticsUtil.analyticAction(
      config.analytics.analytics_experience_view,
      config.analytics.analytics_event_method_appeared,
      'PageLoaded'
    );
  }
  componentWillUnmount() {
    AccountsStore.removeChangeListener(this.onAccountStore);
    MoveMoneyStore.removeChangeListener(this.onStoreChange);
    MoveMoneyPayeeStore.removeChangeListener(this.onPayeeStoreChange);
    MoveMoneyStore.resetPaymentData();
    MoveMoneyPayeeStore.resetStore();
  }
  onAccountStore() {
    this.setState({
      showLoader: false,
      getFromAccounts: MoveMoneyStore.getFromAccountsFromAccountsStore(),
      getToAccounts: MoveMoneyStore.getToAccountsFromAccountsStore(),
    });
  }
  onPayeeStoreChange() {
    this.setState({ payeeList: this.getPayees() });
    if (
      MoveMoneyPayeeStore.getAddPayeeFlag() ||
      MoveMoneyPayeeStore.getCompanyAddedFlag() ||
      MoveMoneyPayeeStore.getEditPayeeFlag()
    ) {
      this.setState({ getFromAccounts: MoveMoneyStore.AddPayeeFromList() });
    }
    if (MoveMoneyPayeeStore.deletePayeeResponseForMoveMoney().code === 201) {
      this.setState({ deletePayee: true });
    } else {
      this.setState({ deletePayee: false });
    }
  }

  onStoreChange() {
    // get the payee list from the payee store not from move money store
    const makePaymentResponse = MoveMoneyStore.getMakePaymentResponse();
    if (makePaymentResponse) {
      this.viewLoader(false);
      this.handleServiceCall(makePaymentResponse);
    } else if (MoveMoneyStore.getSpendingFlag()) {
      this.setState({
        getToAccounts: MoveMoneyStore.getToAccountsFromAccountsStore(),
        payeeList: this.getPayees(),
        getFromAccounts: MoveMoneyStore.getFromAccountsFromAccountsStore(),
      });
    } else {
      if (
        MoveMoneyPayeeStore.getEditPayeeFlag() ||
        MoveMoneyPayeeStore.getAddPayeeFlag() ||
        MoveMoneyPayeeStore.getCompanyAddedFlag()
      ) {
        this.setState({
          getFromAccounts: MoveMoneyStore.AddPayeeFromList(),
          getToAccounts: MoveMoneyStore.getToAccountsFromAccountsStore(),
          payeeList: this.getPayees(),
        });
      } else {
        this.setState({
          getFromAccounts: MoveMoneyStore.getFromAccountsFromAccountsStore(),
          getToAccounts: MoveMoneyStore.getToAccountsFromAccountsStore(),
          payeeList: this.getPayees(),
        });
      }
    }

    if (!MoveMoneyStore.getReviewFlag()) {
      this.setState({
        showSoftTokenAlternative: false,
      });
    }
  }
  getPayees() {
    const { isSMEUser } = this.props;
    return isSMEUser
      ? MoveMoneyStore.getAllPayees()
      : MoveMoneyStore.getAllSavedPayees();
  }
  backClick(e) {
    window.scroll(0, 0);
    this.setState({ showErrorModalState: false });
    MoveMoneyActionCreator.goBackToRepeatPayment('RP');
    if (!_.isEmpty(e)) {
      e.preventDefault();
    }
  }
  // function to navigate back to move money page by using managePayee state
  backFromManagePayee(backToMoveMoneyPage = false) {
    window.scroll(0, 0);
    if (window.cdApi) window.cdApi.changeContext('REQUEST_PAYMENT');
    const backUrl = MoveMoneyStore.getBackUrl();
    if (backUrl && !backToMoveMoneyPage) {
      InternetBankingActions.navigateToWebTask(backUrl);
      MoveMoneyActionCreator.saveNavigationReference(undefined);
    } else {
      this.setState({
        hideMoveMoneyAfterThankYou: false,
        managePayee: false,
        showAddPayeeState: false,
        showList: false,
        showFromList: false,
        showToList: false,
        fromAccount: '',
        toAccount: '',
        isCssSelected: '',
        toPayee: '',
        nextStep: 'From',
        fromFlag: '',
        selectedAccount: '',
        selectedToAccount: '',
        selectedPayee: '',
        toPayeeSelected: '',
        selectedFromData: '',
        selectedToData: '',
        isRepeatPayment: false,
        fromCardSelected: '',
        amount: 0,
        potOpen: false,
        enableSearchIcon: false,
        savingsFromAccountFalg: false,
        savingsToAccountFalg: false,
        loaderstatus: false,
        showThankYouPage: false,
        getFromAccounts: MoveMoneyStore.getFromAccountsFromAccountsStore(),
        getToAccounts: MoveMoneyStore.getToAccountsFromAccountsStore(),
      });
      MoveMoneyStore.resetPaymentData();
      this.forceUpdate();
      MoveMoneyPayeeStore.resetFlags();
    }
  }
  closeErrorModal(isAmountFocus) {
    if (this.state.otpButton === true) {
      this.setState({ showErrorModalState: false, amountFocus: false });
    } else if (isAmountFocus) {
      this.setState({ amountFocus: true });
    } else {
      this.setState({ showErrorModalState: false, amountFocus: false });
    }
  }

  closeModal() {
    window.scrollTo(0, 0);
    this.setState({ closeModal: false, showDelete: false });
    MoveMoneyPayeeStore.resetStore();
  }

  closeTraPop() {
    this.setState({ closeTraPop: false });
  }
  // Sets the state for confirmCancel on cancel click
  closed() {
    this.setState({
      confirmCancel: false,
    });
  }
  // Returns the Modal for Credit Details
  creditPopUp() {
    return (
      <div>
        {this.props.contents.creditPopUpBody}
        <div className="col-xs-12">
          <div className="col-xs-6">
            <button
              onClick={this.closed}
              className="btn btn-primary"
              data-anchor="confirm-cancel-button"
              type="button"
            >
              Cancel
            </button>
          </div>
          <div className="col-xs-6">
            <button
              onClick={this.creditokClick}
              className="btn btn-primary"
              data-anch
              or="confirm-cancel-button"
              type="button"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    );
  }
  // Sets the state for confirmCancel on Ok click
  creditokClick() {
    this.setState({
      confirmCancel: false,
    });
    MoveMoneyActionCreator.postRepeatPaymentData();
  }
  crossClick() {
    this.setState({ closeModal: false, showDelete: false });
    window.scrollTo(0, 0);
    MoveMoneyPayeeStore.resetStore();
  }
  deleteClick() {
    this.setState({
      closeModal: true,
      showDelete: true,
    });

    const detetePayeeRequestPacket = {
      beneficiary_id: this.state.deletePayeeData.id,
      accountId: this.state.deletePayeeData.account.id,
    };
    MoveMoneyPayeeActionCreator.deletePayee(detetePayeeRequestPacket);
  }
  deletePayeeClick(data) {
    this.setState({
      showDelete: true,
      deletePayeeData: data,
      closeModal: true,
    });
  }
  editClickFromPayee(data) {
    const srdCheckRequired =
      data.hasOwnProperty('biller_id') || data.cop_account_type === 'Business';
    if (srdCheckRequired) {
      this.setState({ showLoader: true });
      MoveMoneyPayeeActionCreator.verifySRDPayee(
        `${data.to_account.sort_code}${data.to_account.account_number}`
      );
    }
    this.setState({ managePayee: true, showEditPayee: true, editData: data });
  }
  editManagePayeeClick(data) {
    const srdCheckRequired =
      data.hasOwnProperty('biller_id') || data.cop_account_type === 'Business';
    if (srdCheckRequired) {
      this.setState({ showLoader: true });
      MoveMoneyPayeeActionCreator.verifySRDPayee(
        `${data.to_account.sort_code}${data.to_account.account_number}`
      );
    }
    this.setState({ showEditPayee: false });
  }
  filterAccountList() {
    const filterAccount = [];
    _.map(AccountsStore.getAccounts(), (account) => {
      if (
        account.actionsAvailable['/account/payments/uk/default/out'] === true
      ) {
        filterAccount.push(account);
      }
    });
    return filterAccount;
  }

  goToManagePayees() {
    window.scrollTo(0, 0);
    this.setState({
      managePayee: true,
      showAddPayeeState: false,
      getFromAccounts: MoveMoneyStore.getFromAccountsFromAccountsStore(),
      getToAccounts: MoveMoneyStore.getToAccountsFromAccountsStore(),
    });
    MoveMoneyStore.resetPaymentData();
    MoveMoneyPayeeStore.resetFlags();
  }
  gotToMoveMoneyPage() {
    this.setState({
      showList: false,
      showFromList: false,
      showToList: false,
      fromAccount: '',
      toAccount: '',
      isCssSelected: '',
      toPayee: '',
      nextStep: 'From',
      fromFlag: '',
      selectedAccount: '',
      selectedToAccount: '',
      selectedPayee: '',
      fromCardSelected: '',
      toPayeeSelected: '',
      selectedFromData: '',
      selectedToData: '',
      isRepeatPayment: false,
      amount: 0,
      potOpen: false,
      enableSearchIcon: false,
      savingsFromAccountFalg: false,
      savingsToAccountFalg: false,
      loaderstatus: false,
      inputValue: '',
      getFromAccounts: MoveMoneyStore.getFromAccountsFromAccountsStore(),
      getToAccounts: MoveMoneyStore.getToAccountsFromAccountsStore(),
    });
    MoveMoneyStore.resetPaymentData();
  }
  handleServiceCall(makePaymentResponse) {
    // this is for soft token after authorization
    MoveMoneyApiUtils.isSourceIdSame(false);
    if (makePaymentResponse.code === 202) {
      this.setState({ showThankYouPage: true, showLoader: false }); // TODO Refactor
      //	MoveMoneyStore.setThankyouFlag(true);
    } else if (makePaymentResponse.code === 422) {
      //    // this is for soft token after authorization
      this.setState({ callPaymentService: false });
      //	this.handleServiceError(makePaymentResponse);
      if (parseInt(makePaymentResponse.error.code) === 401) {
        const messages =
          "This payment can't be made as it take you over the daily transaction limit for internet banking.";
        makePaymentResponse.error.verification_type === 'HARD'
          ? this.renderSoftTokenAlternative(true)
          : this.showErrorModal(messages, true);

        // this.showLimitModal();
        //  this.setState({ showThankYou: true });
      } else if (parseInt(makePaymentResponse.error.code) === 404) {
        this.showErrorModal(makePaymentResponse.error.code, false);
      } else {
        // this.setState({ showError: true, errorState: makePaymentResponse.error });
        this.showErrorModal(makePaymentResponse.error.message, false);
        // this.handleError(makePaymentResponse.error);
      }
    }
  }
  hideAddPayee() {
    window.scroll(0, 0);
    this.setState({ showAddPayeeState: false });
  }
  isFromEditPayee() {
    return !_.isEmpty(MoveMoneyStore.getSelectedPayee()) &&
      _.isEmpty(MoveMoneyStore.getSelectedFromAccount())
      ? MoveMoneyStore.AddPayeeFromList()
      : MoveMoneyStore.getFromAccountsFromAccountsStore();
  }
  // function to navigate to manage your payee by using managePayee state
  navigateToManagePayee(e) {
    // Entry point to show manage payee page
    this.setState({
      hideMoveMoneyAfterThankYou: false,
      managePayee: true,
      showAddPayeeState: false,
      showList: false,
      showFromList: false,
      showToList: false,
      fromAccount: '',
      toAccount: '',
      isCssSelected: '',
      toPayee: '',
      nextStep: 'From',
      fromFlag: '',
      selectedAccount: '',
      selectedToAccount: '',
      selectedPayee: '',
      toPayeeSelected: '',
      selectedFromData: '',
      selectedToData: '',
      isRepeatPayment: false,
      fromCardSelected: '',
      amount: 0,
      potOpen: false,
      enableSearchIcon: false,
      savingsFromAccountFalg: false,
      savingsToAccountFalg: false,
      loaderstatus: false,
      showThankYouPage: false,
      getFromAccounts: MoveMoneyStore.getFromAccountsFromAccountsStore(),
      getToAccounts: MoveMoneyStore.getToAccountsFromAccountsStore(),
    });
    MoveMoneyStore.resetPaymentData();
    MoveMoneyPayeeStore.resetStore();
    this.forceUpdate();
    MoveMoneyPayeeStore.resetFlags();
    e.preventDefault();
  }
  navigateToManagePayments(e) {
    e.preventDefault();
    ManagePaymentActionCreator.saveNavigationReference('WEB-OPEN-MOVEMONEY');
    InternetBankingActions.navigateToWebTask('WEB-MANAGE-PAYMENT');
  }
  refreshMoveMoney() {
    MoveMoneyStore.resetPaymentData();
    MoveMoneyPayeeStore.resetStore();
    this.setState({
      showThankYouPage: false,
      getFromAccounts: MoveMoneyStore.getFromAccountsFromAccountsStore(),
    });
  }
  handleRefreshForRepeatingPotPaymentSetup = () => {
    MoveMoneyPayeeStore.resetStore();
    this.setState({
      showThankYouPage: false,
      getFromAccounts: MoveMoneyStore.getFromAccountsFromAccountsStore(),
    });
  };
  resetPaymentFlag() {
    this.setState({ resetPaymentData: false });
  }
  showAddPayeePage(e) {
    // Entry point to show add payee page
    this.setState({ showAddPayeeState: true });
    e.preventDefault();
  }
  showErrorModal(errorText, otp) {
    // callPaymentService : false:this is for soft token after authorization
    if (otp === true) {
      this.setState({
        loaderstatus: false,
        showErrorModalState: true,
        errorText,
        otpButton: true,
        callPaymentService: false,
      });
    } else {
      this.setState({
        loaderstatus: false,
        showErrorModalState: true,
        errorText,
        otpButton: false,
        callSoftTokenWindow: true,
        callPaymentService: false,
      });
    }
  }
  showMoveMoneyPage(props = {}) {
    window.scrollTo(0, 0);
    if (this.state.selectedAccount != '') {
      this.setState({
        managePayee: false,
        showList: false,
        showToList: false,
        toCss: '',
        showEditPayee: false,
        ...props,
      });
    } else {
      this.setState({
        managePayee: false,
        showList: true,
        showToList: false,
        toCss: '',
        fromCardSelected: '',
        showEditPayee: false,
        ...props,
      });
    }
  }
  viewLoader(showLoader = false) {
    this.setState({
      showLoader,
    });
  }

  renderMoveMoneyOrThankYou() {
    const { showSoftTokenAlternative } = this.state;
    const { session } = this.props;

    return (
      <MoveMoneyFromToComponent
        {...this.props}
        fromAccounts={this.state.getFromAccounts}
        toAccounts={this.state.getToAccounts}
        payeeList={this.state.payeeList}
        content={this.props.content}
        session={session}
        envConfig={envConfig}
        showAddPayeePage={this.showAddPayeePage}
        editClickFromPayee={this.editClickFromPayee}
        deletePayeeClick={this.deletePayeeClick}
        navigateToManagePayee={this.navigateToManagePayee}
        navigateToManagePayments={this.navigateToManagePayments}
        showLoader={this.state.showLoader}
        viewLoader={this.viewLoader}
        showThankYouPage={this.state.showThankYouPage}
        showErrorModalState={this.state.showErrorModalState}
        refreshMoveMoney={this.refreshMoveMoney}
        errorText={this.state.errorText}
        hideErrorPopUp={this.closeErrorModal}
        otpButton={this.state.otpButton}
        resetPaymentData={this.state.resetPaymentData}
        resetPaymentFlag={this.resetPaymentFlag}
        callPaymentService={this.state.callPaymentService}
        amountFocus={this.state.amountFocus}
        showSoftTokenAlternative={showSoftTokenAlternative}
        disableSoftTokenAlternative={() =>
          this.renderSoftTokenAlternative(false)
        }
        deletePayee={this.state.deletePayee}
        isBatchPayment={this.props.data.isBatchPayment}
        hideQuickLinks={this.state.hideQuickLinks}
        handleRefreshForRepeatingPotPaymentSetup={
          this.handleRefreshForRepeatingPotPaymentSetup
        }
      />
    );
  }

  handleFileUploadInReview(inReview, contentFromPayLib) {
    const modalConfig = {
      displayLeavePopup: inReview,
      title: contentFromPayLib.title,
      body: contentFromPayLib.textBody,
      secondaryButtonText: contentFromPayLib.destructiveActionButtonText,
      primaryButtonText: contentFromPayLib.safeActionButtonText,
    };
    SiteHeaderActionCreator.setModalConfig(modalConfig);
  }
  renderMoveMoneyorManagePayeePage() {
    let bodyContent;
    let footerButtons;
    let reviewModal;
    let modalHeading;
    let size;
    const { session, isSMEUser } = this.props;
    const sessionCOPChecks = AppStore.getSessionCOPChecks();
    if (MoveMoneyPayeeStore.getDeletePayeeLoader()) {
      bodyContent = <LoaderComponent type="small" />;
      size = 'medium';
      modalHeading = '';
      reviewModal = 'c-modal';
      footerButtons = '';
    } else if (this.state.deletePayeeData !== '') {
      let calloutComponentMessage = <div />;
      if (!AccountsStore.isCreditCardUser()) {
        if (this.state.deletePayeeData.hasOwnProperty('biller_id')) {
          calloutComponentMessage = <div />;
        } else {
          calloutComponentMessage = (
            <div className="callout">
              <div className="callout__wrapper">
                <p>
                  <strong>{this.props.content.deletePayeePopUp1}</strong>
                </p>
                <p>
                  {this.props.content.deletePayeePopUp2}
                  <a
                    href="javascript:void(0)"
                    onClick={this.navigateToManagePayments}
                  >
                    {this.props.content.deletePayeePopUp3}
                  </a>
                  .
                </p>
              </div>
            </div>
          );
        }
      }
      if (!this.state.deletePayee) {
        bodyContent = (
          <div className="delete-payee">
            {calloutComponentMessage}
            <dl className="c-definitions delete-payee--list">
              <dt className="c-definitions__key">Name</dt>
              <dd className="c-definitions__value">
                {this.state.deletePayeeData.to_account.name}
              </dd>
              <dt className="c-definitions__key">Nickname</dt>
              {this.state.deletePayeeData.hasOwnProperty('display_name') &&
              this.state.deletePayeeData.display_name !== '' ? (
                <dd className="c-definitions__value">
                  {this.state.deletePayeeData.display_name}
                </dd>
              ) : (
                <dd className="c-definitions__value">-</dd>
              )}
              <dt className="c-definitions__key">Sort code</dt>
              <dd className="c-definitions__value">
                {this.state.deletePayeeData.to_account.sort_code}
              </dd>

              <dt className="c-definitions__key">Account number</dt>
              <dd className="c-definitions__value">
                {this.state.deletePayeeData.to_account.account_number}
              </dd>

              <dt className="c-definitions__key">Reference</dt>
              <dd className="c-definitions__value">
                {this.state.deletePayeeData.reference}
              </dd>
            </dl>
          </div>
        );
        modalHeading = this.props.content.deletePopupHeading;
        reviewModal = 'c-modal';
        size = 'large';
        footerButtons = (
          <div className="delete-payee__options">
            <button
              type="button"
              className="c-btn c-btn--secondary c-modal__button"
              onClick={this.closeModal}
            >
              Close
            </button>
            <button
              type="button"
              className="c-btn c-btn--default c-modal__button"
              onClick={this.deleteClick}
            >
              {this.props.content.deletePopupBtn}
            </button>
          </div>
        );
      } else {
        bodyContent = (
          <div className="delete-payee--success">
            <SvgIcon id="icon-success" width="128px" height="128px" />
            {this.state.deletePayeeData.hasOwnProperty('display_name') &&
            this.state.deletePayeeData.display_name !== '' ? (
              <p className="<delete-payee--success__msg">
                {this.state.deletePayeeData.display_name}
                {this.props.content.payeePoupDeleted}
              </p>
            ) : (
              <p className="<delete-payee--success__msg">
                {this.state.deletePayeeData.to_account.name}
                {this.props.content.payeePoupDeleted}
              </p>
            )}
          </div>
        );
        footerButtons = (
          <button
            type="button"
            className="c-btn c-btn--default c-modal__button"
            onClick={this.closeModal}
          >
            OK
          </button>
        );
        reviewModal = 'c-modal c-modal--center';
        modalHeading = '';
        size = 'medium';
      }
    }
    const containerClass = cx({ 'business-only': isSMEUser });
    return (
      <div id="moveMoneyContainer" className={containerClass}>
        {this.state.showDelete ? (
          <PatternLibModalComponent
            show={this.state.closeModal}
            customClass={reviewModal}
            onHide={this.crossClick}
            bsSize={size}
            modalHeading={modalHeading}
            modalBody={bodyContent}
            modalFooter={footerButtons}
            modalInContainer={false}
            closeButton
            backdrop="static"
          />
        ) : (
          ''
        )}
        {this.state.managePayee ? (
          isSMEUser ? (
            <ManageYourPayee
              accounts={AccountsStore.getAll()}
              copCheckTriggered={copCheckTriggeredHandler}
              session={getSessionInfo(session)}
              envConfig={envConfig}
              user={UserManagementStore.getCADetails()}
              handleBack={this.backFromManagePayee}
              handleRoute={(route) =>
                InternetBankingActions.navigateToWebTask(route)
              }
              handleFileUploadInReview={this.handleFileUploadInReview}
              gotToMoveMoneyPage={this.backFromManagePayee}
              fetchParentBeneficiary={() =>
                MoveMoneyActionCreator.getFromPayeeList()
              }
              sessionCOPChecks={sessionCOPChecks}
            />
          ) : (
            <ManagePayeePage
              envConfig={envConfig}
              content={this.props.content}
              backClick={this.backFromManagePayee}
              payeeData={this.state.payeeList.beneficiaries}
              deletePayee={this.state.deletePayee}
              goToMoveMoneyPage={this.showMoveMoneyPage}
              showEditPayee={this.state.showEditPayee}
              editManagePayeeClick={this.editManagePayeeClick}
              goToManagePayee={this.resetForEdit}
              editData={this.state.editData}
              isSMEUser={this.props.isSMEUser}
              session={getSessionInfo(session)}
              user={UserManagementStore.getCADetails()}
            />
          )
        ) : (
          this.renderMoveMoneyOrThankYou()
        )}
      </div>
    );
  }
  renderSoftTokenAlternative(showSoftTokenAlternative) {
    if (this.state.showSoftTokenAlternative !== showSoftTokenAlternative) {
      this.setState({ showSoftTokenAlternative });
    }
  }
  render() {
    const { session } = this.props;
    return (
      <BioCatchContext context={REQUEST_PAYMENT_CONTEXT}>
        <div className="bow page">
          <Helmet
            title={this.props.isSMEUser ? 'Make a payment' : 'Move money'}
          />
          {this.state.showAddPayeeState ? (
            <AddPayeeOrCompanyMainPage
              content={this.props.content}
              isSMEUser={this.props.isSMEUser}
              goToMoveMoneyPage={this.hideAddPayee}
              goBackToMoveMoney={this.hideAddPayee}
              goToManagePayees={this.goToManagePayees}
              filterAccountList={this.filterAccountList}
              session={getSessionInfo(session)}
              envConfig={envConfig}
              user={UserManagementStore.getCADetails()}
            />
          ) : (
            this.renderMoveMoneyorManagePayeePage()
          )}
        </div>
      </BioCatchContext>
    );
  }
}

MoveMoney.propTypes = {
  isSMEUser: PropTypes.bool.isRequired,
  content: PropTypes.object.isRequired,
  data: PropTypes.shape({
    isBatchPayment: PropTypes.bool,
  }).isRequired,
  session: PropTypes.shape({
    accessToken: PropTypes.string.isRequired,
  }).isRequired,
};

export default RequiresAuthenticatedUser(MoveMoney);
